import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import VerifyView from './verify.view';
import authServices from '../../../services/auth-service';
import Spinner from '../../../Common/Spinner';
import NotVerify from './notVerify.view';
import { router } from '../../../Routes/routhPaths';
import SnackAlert from '../../../Common/Alerts';

function VerifyUtils(props) {
  let navigate = useNavigate();
  const {token} = useParams();
  const [searchParams] = useSearchParams();
  const returnURL = searchParams.get("returnURL");
  const [showSpinner, setShowSpinner] = useState(false);
  const [verified, setVerified] = useState(false);
  const [apiCalled, setApiCalled] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [severity, setSeverity] = useState('');

  useEffect(()=>{
    verify();
  },[])
  
  const verify = async()=> {
    setShowSpinner(true);
    const res = await authServices.verify({token : token});
    if(res.data.auth && returnURL){
      setAlertMessage('Your account has been verified successfully.');
      setSeverity('success');
      setShowAlert(true);
      const userRes = await authServices.login({...res.data.user, org_id: props.org._id});
          if(userRes.data.auth){
            sessionStorage.setItem('userLogged', JSON.stringify(res.data));
            if(returnURL){
              navigate(returnURL);
            }else if(userRes.data.result.role === "root"){
              navigate(router.dashboard)
            }else if(userRes.data.result.role === "admin"){
              let permission = userRes.data.result?.permissions.filter(x=>x.can_view == true);
              navigate(router.suite +"/"+ permission[0].module.key);
            }else{
              navigate(router.main);
            }
          }else{
            setAlertMessage(userRes.data.msg);
            setSeverity('error');
            setShowAlert(true);
          }
          setShowSpinner(false);
    }else{
      setApiCalled(true);
      setVerified(res.data.auth);
    }
    setShowSpinner(false);
  }

  return (
    <>
      {apiCalled && verified && <VerifyView org={props.org}/>}
      {apiCalled && !verified && <NotVerify org={props.org}/>}
      <Spinner
        spinner = {showSpinner}
      />
      <SnackAlert
        alertMessage = {alertMessage}
        showAlert = {showAlert}
        severity = {severity}
        
        closeAlert = {()=>setShowAlert(!showAlert)}
      />
    </>
  );
}

export default VerifyUtils;